import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Namespace } from 'enums-lib';
import { BullhornMetaDataServiceImpl } from '../../interfaces/BullhornMetaDataServiceImpl';
import { BaseMetaDataService } from './base-meta-data.service';

@Injectable({ providedIn: 'root' })
export class BullhornMetaDataService extends BaseMetaDataService {
  constructor(http: HttpClient) {
    super(http, Namespace.bullhorn, new BullhornMetaDataServiceImpl());
  }
}
